module.exports = __webpack_public_path__ + "img/SAPICAFC.e5bad9ed.png";